import { render, staticRenderFns } from "./CoinRotateCenterIcon.vue?vue&type=template&id=1481607e&"
import script from "./CoinRotateCenterIcon.vue?vue&type=script&lang=ts&"
export * from "./CoinRotateCenterIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports